import './get_highest_value';
import './get_lowest_value';
import './get_index_when';


// WEBPACK FOOTER //
// ./src/botPage/view/blockly/blocks/lists/index.js